import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { BaseView } from '../../base-view';
import { NgForOfContext } from '@angular/common';
import { RequestHandler } from '../../../service/OffService/request-handler';
import { Form } from '../../../common/components/reactive-form-builder/interfaces/form.interface';

/**
 * Generic modal host that renders Info/Delete dialogs backed by BaseView.
 * It wires app-reactive-form-builder for both flows and delegates hide/delete actions to the provided view.
 */
@Component({
  selector: 'app-modals',
  standalone: false,
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.scss']
})
export class ModalsComponent<T> {
  /** View contract used to control visibility and actions. */
  @Input() public view!: BaseView<T>;

  /** Reactive form-builder inputs shared by both dialogs. */
  @Input() public form: Form<T> | undefined;
  
  @Input() public serverUrl!: string;
  
  @Input() public previousData!: T;

  /** Extra flags/requests used by Delete dialog. */
  @Input() public recordHasAssociatedData = false;
  
  @Input() public getRequest!: RequestHandler<T[]>;
  
  @Input() public deleteRequest!: RequestHandler<T>;

  /** Optional content projection (unused now, kept for backward compatibility). */
  @ContentChild('content', { read: false, static: false })
  public content?: TemplateRef<NgForOfContext<object, object[]>>;

  /** Scroll to top when a dialog becomes visible. */
  public scrollToTop(): void {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      /* no-op */
    }
  }
}
